/**
 * ตรวจสอบสิทธิ์การเข้าถึงเมนูจัดการข้อมูลหลัก (Master Data) ของระบบหอพัก
 * เงื่อนไขตามคำสั่งผู้ใช้งาน:
 * "ในระบบนี้ ให้มองเห็นแท็บเดียวก่อนและสิทธิ์ที่เห็นคืองานคอมกับงานบริหาร"
 */
export const checkDormitoryMasterDataPermission = () => {
  try {
    // 1. รองรับการทดสอบสลับมุมมองผ่าน query param (เช่น ?preview_role=viewer หรือ ?preview_role=manager)
    if (typeof window !== "undefined" && window.location) {
      const params = new URLSearchParams(window.location.search);
      if (params.get("preview_role") === "manager") return true;
      if (params.get("preview_role") === "viewer") return false;
    }

    const raw = localStorage.getItem("currentUser");
    if (!raw) return false;
    const currentUser = JSON.parse(raw);

    // 2. Super Admin หรือผู้ดูแลระบบ
    const userName = (currentUser.userName || currentUser.username || "").toLowerCase();
    if (
      userName === "madarakung" ||
      currentUser.role === "Admin" ||
      currentUser.role === "admin" ||
      currentUser.isAdmin === true ||
      currentUser.userLevelKey === -1
    ) {
      return true;
    }

    // 3. ตรวจสอบกลุ่มงานใน userDepartment
    const userDepts = Array.isArray(currentUser.userDepartment) ? currentUser.userDepartment : [];

    const isAuthorized = userDepts.some((dept) => {
      // ตรวจสอบ DepartmentKey:
      // 108 = กลุ่มงานเทคโนโลยีสารสนเทศ (งานคอม)
      // 140 = งานสารสนเทศ / Admin
      // 105 = กลุ่มงานบริหารทั่วไป / HR
      // 143 = Admin / ผู้ดูแล
      const deptKey = dept.departmentKey || dept.DepartmentKey;
      if (deptKey === 105 || deptKey === 108 || deptKey === 140 || deptKey === 143) {
        return true;
      }

      // ตรวจสอบชื่อกลุ่มงาน (ภาษาไทย / อังกฤษ)
      const deptName = (
        dept.departmentName ||
        dept.DepartmentName ||
        dept.department?.name ||
        dept.name ||
        dept.groupWorkName ||
        ""
      ).toLowerCase();

      // 3.1 งานคอมพิวเตอร์ / สารสนเทศ
      const isComputer =
        deptName.includes("คอม") ||
        deptName.includes("สารสนเทศ") ||
        deptName.includes("it") ||
        deptName.includes("computer") ||
        deptName.includes("ดิจิทัล");

      // 3.2 งานบริหาร / อำนวยการ / ธุรการ / สารบรรณ
      const isAdministration =
        deptName.includes("บริหาร") ||
        deptName.includes("อำนวยการ") ||
        deptName.includes("ธุรการ") ||
        deptName.includes("สารบรรณ") ||
        deptName.includes("admin");

      return isComputer || isAdministration;
    });

    if (isAuthorized) return true;

    // 4. ตรวจสอบชื่อแผนก/กลุ่มงานที่ระดับบนสุดของ User
    const topDept = (currentUser.departmentName || currentUser.department || "").toLowerCase();
    if (
      topDept.includes("คอม") ||
      topDept.includes("สารสนเทศ") ||
      topDept.includes("it") ||
      topDept.includes("computer") ||
      topDept.includes("ดิจิทัล") ||
      topDept.includes("บริหาร") ||
      topDept.includes("อำนวยการ") ||
      topDept.includes("ธุรการ") ||
      topDept.includes("สารบรรณ") ||
      topDept.includes("admin")
    ) {
      return true;
    }

    return false;
  } catch (err) {
    console.error("Error checking dormitory master data permission:", err);
    return false;
  }
};

